import { useState, type FormEvent } from 'react';
import { submitForm } from '@/lib/formSubmit';

const ENDPOINT = 'https://readdy.ai/api/form/dahc96bp14a1h3mr6ie0';

export default function NewsletterSubscribe() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus('loading');
    setFormError('');
    const result = await submitForm(form, ENDPOINT);
    if (result.ok) {
      setStatus('success');
      form.reset();
      return;
    }
    setStatus('error');
    setFormError(result.message || '订阅失败，请稍后再试');
  };

  return (
    <section className="bg-primary-100/70 py-14 md:py-16">
      <div className="mx-auto grid max-w-[1400px] items-center gap-8 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-mail-send-line w-3.5 h-3.5 flex items-center justify-center" />
            每日精选
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">
            把今天最好笑的内容，打包寄给你
          </h2>
          <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-700 md:text-base">
            每天 20:00 精选 8 条当日笑料与热瓜，一封简讯看完，不打扰、不刷屏，随时可以退订。
          </p>
        </div>

        <div className="rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-6">
          {status === 'success' ? (
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-checkbox-circle-line w-5 h-5 flex items-center justify-center text-xl" />
              </span>
              <div>
                <p className="font-medium text-foreground-900">订阅成功，收到啦</p>
                <p className="mt-1 text-sm text-foreground-600">
                  明天 20:00 你会收到第一封精选简讯。
                </p>
              </div>
            </div>
          ) : (
            <form data-readdy-form id="newsletter-form" onSubmit={handleSubmit} className="space-y-3">
              <label htmlFor="newsletter-email" className="block text-sm font-medium text-foreground-800">
                你的邮箱
              </label>
              <div className="flex flex-col gap-3 sm:flex-row">
                <input
                  id="newsletter-email"
                  name="email"
                  type="email"
                  required
                  placeholder="you@example.com"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200 placeholder:text-foreground-400"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  {status === 'loading' ? '提交中…' : '免费订阅'}
                </button>
              </div>
              <input
                className="form-honeypot"
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              {status === 'error' && (
                <p className="text-sm text-accent-700">{formError}</p>
              )}
              <p className="text-xs text-foreground-500">
                我们仅用于发送内容简讯，不会把你的邮箱用于其他用途。
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}